import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import type { Features } from '../../features'

export function useTrustmark() {
  const {
    features: { trustmark, trustmarkConfig },
  } = useMarketplace<Features>()

  const withTrustedShops = computed(
    () => trustmark === 'trusted-shops' || trustmark === 'confianza-online',
  )

  const withTrustpilot = computed(() => trustmark === 'trustpilot')

  return {
    withTrustedShops,
    withTrustpilot,
    trustmarkConfig,
  }
}
